import appConstants from "../../../../../appConstants";

export const defectsFilterOptions = [
  {
    value: "H",
    text: "High severity",
  },
  {
    value: "L",
    text: "Low severity",
  },
];

export const getDefectsFilterValue = (params) => {
  if (params.data.defects?.length === 0) {
    return "";
  }
  const severity = params.data.defects?.some(
    (defect) => defect.severity == appConstants.DEFECTS_SEVERITY_TYPES.H
  );
  return severity ? appConstants.DEFECTS_SEVERITY_TYPES.H : appConstants.DEFECTS_SEVERITY_TYPES.L;
};
